import React from 'react';

import { IIconProps } from './constants';

export const MapIcon = ({
  height = 24,
  width = 24,
  strokeWidth = 2,
  title = '',
  ariaLabel = '',
  ariaHidden = false,
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={ariaLabel}
    aria-hidden={ariaHidden}
  >
    {title && <title>{title}</title>}

    <path
      d="M1.33398 8.0013V29.3346L10.6673 24.0013L21.334 29.3346L30.6673 24.0013V2.66797L21.334 8.0013L10.6673 2.66797L1.33398 8.0013Z"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.666 2.66797V24.0013"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.334 8V29.3333"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
